export default __webpack_public_path__ + "static/media/ReportIcon-Video-MS.b7cf1f63.jpg";